(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var reasonSelect = document.getElementById('ContactForm-reason');
    var existingOrderFields = document.getElementById('ContactForm-existing-order-fields');

    if (!reasonSelect || !existingOrderFields) return;

    function toggleExistingOrderFields() {
      if (
        reasonSelect.value === 'Existing Order' ||
        reasonSelect.value === 'Customer order'
      ) {
        existingOrderFields.style.display = 'block';
      } else {
        existingOrderFields.style.display = 'none';
      }
    }

    reasonSelect.addEventListener('change', toggleExistingOrderFields);
    toggleExistingOrderFields();
  });
  } catch(e) { console.error(e); }
})();

})();
